import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=d59a9b8c&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d59a9b8c')) {
      api.createRecord('d59a9b8c', component.options)
    } else {
      api.reload('d59a9b8c', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=d59a9b8c&", function () {
      api.rerender('d59a9b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contacts/list/Index.vue"
export default component.exports